export const INSERT_USER_PROFILE_DETAIL_MUTATION = `
  mutation InsertUserProfileDetail($input: UserProfileDetailInsertInput!) {
    insertUserProfileDetail(input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

export const UPDATE_USER_PROFILE_DETAIL_MUTATION = `
  mutation UpdateUserProfileDetail($filter: String!, $input: UserProfileDetailUpdateInput!) {
    updateUserProfileDetail(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

export const INSERT_USER_CONTACT_DETAIL_MUTATION = `
  mutation InsertUserContactDetail($input: UserContactDetailInsertInput!) {
    insertUserContactDetail(input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

export const UPDATE_USER_CONTACT_DETAIL_MUTATION = `
  mutation UpdateUserContactDetail($filter: String!, $input: UserContactDetailUpdateInput!) {
    updateUserContactDetail(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

export const INSERT_HR_PROFILE_MUTATION = `
  mutation InsertUserHRPeriodicalProfile($input: UserHRPeriodicalProfileInsertInput!) {
    insertUserHRPeriodicalProfile(input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

export const UPDATE_HR_PROFILE_MUTATION = `
  mutation UpdateUserHRPeriodicalProfile($filter: String!, $input: UserHRPeriodicalProfileUpdateInput!) {
    updateUserHRPeriodicalProfile(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

// Legacy `AddKosovoActionLogAsync`: Kosovo's HR keeps a per-employee action log next to the activity log.
export const INSERT_ACTION_LOG_MUTATION = `
  mutation InsertActionLog($input: ActionLogInsertInput!) {
    insertActionLog(input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;

// Legacy `HrFineComponent`/`MakeFineCommand`: an HR admin issuing an ad-hoc lunch or
// non-compliance fine to an employee from the directory list.
export const INSERT_FINE_MUTATION = `
  mutation InsertFine($input: FineInsertInput!) {
    insertFine(input: $input) {
      itemId
      totalImpactedData
      acknowledged
      message
    }
  }
`;
